import { render } from "./FAQSectionLayout.vue?vue&type=template&id=481295a5"
const script = {}

import "./FAQSectionLayout.vue?vue&type=style&index=0&id=481295a5&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__